
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 2)","stroke":"#FFF","stroke-width":"1.2","fill":"none","fill-rule":"evenodd"}},[_c('path',{staticClass:"fill",attrs:{"fill":"#000","d":"M4.4 1.4V.75c0-.367.136-.697.394-.956.26-.258.589-.394.956-.394h4.5c.367 0 .697.136.956.394.258.26.394.589.394.956v.65h2.15c.503 0 .95.186 1.307.543.357.357.543.804.543 1.307v7.5c0 .503-.186.95-.543 1.307a1.803 1.803 0 01-1.307.543H2.25c-.503 0-.95-.186-1.307-.543A1.803 1.803 0 01.4 10.75v-7.5c0-.503.186-.95.543-1.307A1.803 1.803 0 012.25 1.4H4.4z"}}),_c('path',{attrs:{"d":"M.5 6.6l15-.1"}}),_c('rect',{attrs:{"fill":"#FFF","fill-rule":"nonzero","x":"6.4","y":"5.5","width":"3.2","height":"2.2","rx":"1"}}),_c('path',{attrs:{"d":"M6.5 1.5h3"}})])])
          )
        }
      }
    